import React from 'react';
import { motion } from "framer-motion";
import "../../styles/FounderSection.css";
import founder from '../../images/Mahesh_VJ.avif';
import usePauseOnOutOfView from "../../../Hooks/usePauseOnOutOfView";
import BubbleBackground from "../../common/BubbleBackground";



const FounderSection = () => {
    const sectionRef = usePauseOnOutOfView();
    return (
        <section ref={sectionRef} className="founder-section">
            <BubbleBackground />

            <div className="dark-glow-bg"></div>
            <motion.div
                className="founder-card"
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
            >
                <div className="founder-image">
                    {/* "../../images/Mahesh_VJ.jpg" */}
                    <img
                        src={founder} 
                        alt="Mahesh V J - Founder of Sujaramaha Enterprises"
                    />
                </div>

                <div className="founder-content">
                    <span className="founder-tag">Founder & Owner</span>
                    {/*<h2>Mahesh V J</h2>
                    <h3>Managing Director - Sujaramaha Enterprises</h3>

                    <p>
                        <strong>Mahesh V J</strong> is the Founder and Managing Director of 
                         <strong> Sujaramaha Enterprises</strong>, established with a clear vision to
                        deliver <strong>transparent insurance solutions</strong>,
                        <strong>reliable IT services</strong>, and
                        <strong> advanced CCTV & security systems</strong>.
                        His leadership is driven by a strong commitment to
                        <strong> customer trust</strong>, <strong>ethical business practices</strong>,
                        and building <strong>long-term customer relationships</strong>.
                    </p>*/}

                    <h2>Mahesh V J</h2>
                    <h3>Founder & Managing Director of Sujaramaha Enterprises</h3>

                    <p>
                        <strong>Mahesh V J</strong> is the Founder and Managing Director of
                        <strong> Sujaramaha Enterprises</strong>, a professionally managed multi-service
                        organization delivering <strong>insurance solutions</strong>,
                        <strong> IT & computer services</strong>, and
                        <strong> CCTV & security systems</strong> under one roof.
                    </p>

                    <p>
                        With a strong focus on <strong>transparency, reliability, and customer satisfaction</strong>,
                        Mahesh established Sujaramaha Enterprises to simplify services and provide
                        honest guidance across <strong>vehicle, health, and travel insurance</strong>,
                        along with dependable technology and home solutions.
                    </p>

                    <p>
                        His leadership philosophy is centered on <strong>ethical business practices</strong>,
                        continuous service improvement, and building <strong>long-term relationships </strong>
                        with customers, partners, and vendors. Under his direction, the company has
                        earned a reputation for <strong>trust, quality service, and responsive support</strong>.
                    </p>

                    <p>
                        Mahesh V J continues to drive the company forward with a vision to expand
                        innovative services while maintaining a strong commitment to customer care
                        and professional excellence.
                    </p>



                    <div className="founder-highlights">
                        <div>
                            <strong>8+ Years</strong>
                            <span>Industry Experience</span>
                        </div>
                        <div>
                            <strong>5,000+</strong>
                            <span>Clients Served</span>
                        </div>
                        <div>
                            <strong>100%</strong>
                            <span>Customer Focus</span>
                        </div>
                    </div>
                </div>
            </motion.div>
        </section>
    );
};

export default FounderSection;
